/**
 * Shared touch-swipe handling for Evermore review media galleries (the main
 * review carousel + the Top reviews dialog). A swipe that starts on a
 * review's media frames switches that review's own image/video via its
 * existing radio/dot inputs. Swipes starting outside the frames are left
 * untouched so the outer horizontal scroll-snap carousel handles them.
 */
(function () {
  var SWIPE_THRESHOLD = 40;
  var DIRECTION_RATIO = 1.2;
  var AXIS_LOCK_DISTANCE = 10;

  function attachGallery(gallery) {
    if (gallery.dataset.swipeBound === 'true') return;

    var frames = gallery.querySelector('[data-media-frames]');
    var radios = Array.prototype.slice.call(gallery.querySelectorAll('input[type="radio"]'));

    if (!frames || radios.length < 2) return;

    gallery.dataset.swipeBound = 'true';

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var deciding = true;
    var horizontal = false;

    var selectByOffset = function (offset) {
      var currentIndex = radios.findIndex(function (radio) {
        return radio.checked;
      });
      if (currentIndex === -1) return;

      var nextIndex = currentIndex + offset;
      if (nextIndex < 0 || nextIndex >= radios.length) return;

      var target = radios[nextIndex];
      if (target.checked) return;

      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    };

    // Listeners are registered on the capture phase so this wrapper sees the
    // gesture before a nested <video> element's own native touch handling
    // (scrubbing, etc.) can claim it - otherwise a swipe starting directly
    // on a video is silently swallowed by the video instead of reaching us.
    frames.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
        deciding = true;
        horizontal = false;
      },
      { passive: true, capture: true }
    );

    frames.addEventListener(
      'touchmove',
      function (event) {
        if (!tracking || event.touches.length !== 1) return;

        var dx = event.touches[0].clientX - startX;
        var dy = event.touches[0].clientY - startY;

        if (deciding) {
          if (Math.abs(dx) < AXIS_LOCK_DISTANCE && Math.abs(dy) < AXIS_LOCK_DISTANCE) return;
          horizontal = Math.abs(dx) > Math.abs(dy) * DIRECTION_RATIO;
          deciding = false;
        }

        if (horizontal) {
          event.preventDefault();
        }
      },
      { passive: false, capture: true }
    );

    frames.addEventListener(
      'touchend',
      function (event) {
        if (!tracking) return;
        tracking = false;

        if (!horizontal) return;

        var touch = event.changedTouches[0];
        if (!touch) return;

        var dx = touch.clientX - startX;
        if (Math.abs(dx) < SWIPE_THRESHOLD) return;

        selectByOffset(dx < 0 ? 1 : -1);
      },
      { capture: true }
    );

    frames.addEventListener(
      'touchcancel',
      function () {
        tracking = false;
        horizontal = false;
      },
      { capture: true }
    );
  }

  function initReviewMediaSwipe(root) {
    var scope = root || document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-media-gallery]')).forEach(attachGallery);
  }

  window.EvermoreReviewMediaSwipe = initReviewMediaSwipe;
})();
